"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpstreamCollectiveExternalToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AmountTooHigh",
        type: "error",
    },
    {
        inputs: [],
        name: "AmountTooLow",
        type: "error",
    },
    {
        inputs: [],
        name: "DepositsDisabled",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToCallRemote",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToCallRemoteWithValue",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToSendEther",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToSendFee",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransferERC1155",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransferERC721",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransferTokens",
        type: "error",
    },
    {
        inputs: [],
        name: "NotUpstream",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bool",
                name: "enableDeposits",
                type: "bool",
            },
        ],
        name: "EnableDepositsChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "feeAmount",
                type: "uint256",
            },
        ],
        name: "FeePaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "depositFee",
                type: "uint256",
            },
        ],
        name: "FeesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "etherAmount",
                type: "uint256",
            },
        ],
        name: "FundsDeposited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "callRemote",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "callRemoteWithValue",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "depositFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "enableDeposits",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_multisigAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_upstreamWalletAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_depositFee",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155BatchReceived",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "sendEther",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_depositFee",
                type: "uint256",
            },
        ],
        name: "setDepositFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_upstreamWalletAddress",
                type: "address",
            },
        ],
        name: "setUpstreamWalletAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "newValue",
                type: "bool",
            },
        ],
        name: "toggleEnableDeposits",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "callAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferERC1155",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "callAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferERC721",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "callAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokens",
                type: "uint256",
            },
        ],
        name: "transferTokens",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "upstreamWalletAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "0x60806040523480156200001157600080fd5b50600054610100900460ff1615808015620000335750600054600160ff909116105b8062000063575062000050306200013d60201b620012b01760201c565b15801562000063575060005460ff166001145b620000cb5760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b606482015260840160405180910390fd5b6000805460ff191660011790558015620000ef576000805461ff0019166101001790555b801562000136576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b506200014c565b6001600160a01b03163b151590565b611949806200015c6000396000f3fe6080604052600436106101855760003560e01c806379ba5097116100d1578063b83e72b81161008a578063d0e30db011610064578063d0e30db0146105e8578063e30c3978146105f0578063f23a6e611461060f578063f2fde38b1461063b57600080fd5b8063b83e72b81461057c578063bc197c811461059c578063c1756a2c146105c857600080fd5b806379ba5097146104d45780638456cb59146104e95780638700de30146104fe5780638da5cb5b1461051e5780638f7fdca01461053c578063a64b6e5f1461055c57600080fd5b80633f4ba83a1161013e5780635c975abb116101185780635c975abb1461045f5780635e4c57a41461047f57806367a527931461049a578063715018a6146104bf57600080fd5b80633f4ba83a1461040a5780634162c9901461041f578063490ae2101461043f57600080fd5b806301ffc9a7146102f657806305a8fc951461032b5780630a7e880c14610364578063150b7a02146103845780631794bb3c146103c85780631aca6376146103ea57600080fd5b366102f15761012d5460ff166101ae57604051630e2f42c960e31b815260040160405180910390fd5b600034116101cf57604051631fbaba3560e01b815260040160405180910390fd5b60008061012e54116101e25760006101fb565b61012e546101f1606434611380565b6101fb91906113a2565b905080156102ad5761012f546040516000916001600160a01b03169083908381818185875af1925050503d8060008114610251576040519150601f19603f3d011682016040523d82523d6000602084013e610256565b606091505b505090508061027857604051638b3dac3760e01b815260040160405180910390fd5b6040518281527f69e27f80547602d16208b028c44d20f25956e1fb7d0f51d62aa02f392426f3719060200160405180910390a1505b7f543ba50a5eec5e6178218e364b1d0f396157b3c8fa278522c2cb7fd99407d47433604080516001600160a01b0390921682523460208301520160405180910390a1005b600080fd5b34801561030257600080fd5b506103166103113660046113c7565b61065b565b60405190151581526020015b60405180910390f35b34801561033757600080fd5b5061012f5461034c906001600160a01b031681565b6040516001600160a01b039091168152602001610322565b34801561037057600080fd5b5061031661037f366004611408565b610692565b34801561039057600080fd5b506103af61039f366004611501565b630a85bd0160e11b949350505050565b6040516001600160e01b03199091168152602001610322565b3480156103d457600080fd5b506103e86103e3366004611569565b6107b3565b005b3480156103f657600080fd5b50610316610405366004611569565b610933565b34801561041657600080fd5b506103e8610a32565b34801561042b57600080fd5b506103e861043a3660046115a5565b610b06565b34801561044b57600080fd5b506103e861045a3660046115c0565b610b5e565b34801561046b57600080fd5b5061012f54600160a01b900460ff16610316565b34801561048b57600080fd5b5061012d546103169060ff1681565b3480156104a657600080fd5b506104b161012e5481565b604051908152602001610322565b3480156104cb57600080fd5b506103e8610bd0565b3480156104e057600080fd5b506103e8610be4565b3480156104f557600080fd5b506103e8610c5f565b34801561050a57600080fd5b50610316610519366004611622565b610cfb565b34801561052a57600080fd5b506033546001600160a01b031661034c565b34801561054857600080fd5b5061031661055736600461167c565b610db1565b34801561056857600080fd5b50610316610577366004611569565b610e66565b34801561058857600080fd5b506103166105973660046116cf565b610f58565b3480156105a857600080fd5b506103af6105b7366004611771565b63bc197c8160e01b95945050505050565b3480156105d457600080fd5b506103166105e336600461181b565b610fd2565b6103e86110bb565b3480156105fc57600080fd5b50610130546001600160a01b031661034c565b34801561061b57600080fd5b506103af61062a366004611845565b63f23a6e6160e01b95945050505050565b34801561064757600080fd5b506103e86106563660046115a5565b61123e565b60006001600160e01b03198216630271189760e51b148061068c57506301ffc9a760e01b6001600160e01b03198316145b92915050565b600061069c6112bf565b61012f54600160a01b900460ff16156106d05760405162461bcd60e51b81526004016106c7906118aa565b60405180910390fd5b604080513060248201526001600160a01b038681166044830152606482018690526084820185905260a060a4830152600060c4808401919091528351808403909101815260e490920183526020820180516001600160e01b0316637921219560e11b17905291519187169161074591906118d4565b6000604051808303816000865af19150503d8060008114610782576040519150601f19603f3d011682016040523d82523d6000602084013e610787565b606091505b505080915050806107ab576040516319d7576760e01b815260040160405180910390fd5b949350505050565b600054610100900460ff16158080156107d35750600054600160ff909116105b806107ed5750303b1580156107ed575060005460ff166001145b6108505760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b60648201526084016106c7565b6000805460ff191660011790558015610873576000805461ff0019166101001790555b6001600160a01b038416158061089057506001600160a01b038316155b156108ae5760405163d92e233d60e01b815260040160405180910390fd5b61012d805460ff1916600117905561012e82905561012f80546001600160a81b0319166001600160a01b0385161790556108e784611319565b801561092d576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b50505050565b600061093d6112bf565b61012f54600160a01b900460ff16156109685760405162461bcd60e51b81526004016106c7906118aa565b604080513060248201526001600160a01b038581166044830152606480830186905283518084039091018152608490920183526020820180516001600160e01b03166323b872dd60e01b1790529151918616916109c591906118d4565b6000604051808303816000865af19150503d8060008114610a02576040519150601f19603f3d011682016040523d82523d6000602084013e610a07565b606091505b50508091505080610a2b5760405163913e302160e01b815260040160405180910390fd5b9392505050565b61012f546001600160a01b0316336001600160a01b031614610a675760405163fa4a8e2760e01b815260040160405180910390fd5b61012f54600160a01b900460ff16610ab85760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b60448201526064016106c7565b61012f805460ff60a01b191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b61012f546001600160a01b0316336001600160a01b031614610b3b5760405163fa4a8e2760e01b815260040160405180910390fd5b61012f80546001600160a01b0319166001600160a01b0392909216919091179055565b61012f546001600160a01b0316336001600160a01b031614610b935760405163fa4a8e2760e01b815260040160405180910390fd5b61012e8190556040518181527f3dda580d2b9d92da338ef46ec718e7b1dd0a2c505e3df4aa8d40360192a0f822906020015b60405180910390a150565b610bd86112bf565b610be26000611319565b565b6101305433906001600160a01b03168114610c535760405162461bcd60e51b815260206004820152602960248201527f4f776e61626c6532537465703a2063616c6c6572206973206e6f7420746865206044820152683732bb9037bbb732b960b91b60648201526084016106c7565b610c5c81611319565b50565b61012f546001600160a01b0316336001600160a01b031614610c945760405163fa4a8e2760e01b815260040160405180910390fd5b61012f54600160a01b900460ff1615610cbf5760405162461bcd60e51b81526004016106c7906118aa565b61012f805460ff60a01b1916600160a01b1790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258610ae93390565b6000610d056112bf565b61012f54600160a01b900460ff1615610d305760405162461bcd60e51b81526004016106c7906118aa565b846001600160a01b0316828585604051610d4b929190611903565b60006040518083038185875af1925050503d8060008114610d88576040519150601f19603f3d011682016040523d82523d6000602084013e610d8d565b606091505b505080915050806107ab576040516321758d2d60e21b815260040160405180910390fd5b6000610dbb6112bf565b61012f54600160a01b900460ff1615610de65760405162461bcd60e51b81526004016106c7906118aa565b836001600160a01b03168383604051610e00929190611903565b6000604051808303816000865af19150503d8060008114610e3d576040519150601f19603f3d011682016040523d82523d6000602084013e610e42565b606091505b50508091505080610a2b5760405163dcbe522960e01b815260040160405180910390fd5b6000610e706112bf565b61012f54600160a01b900460ff1615610e9b5760405162461bcd60e51b81526004016106c7906118aa565b604080516001600160a01b038581166024830152604480830186905283518084039091018152606490920183526020820180516001600160e01b031663a9059cbb60e01b179052915191861691610ef291906118d4565b6000604051808303816000865af19150503d8060008114610f2f576040519150601f19603f3d011682016040523d82523d6000602084013e610f34565b606091505b50508091505080610a2b57604051637610b93d60e11b815260040160405180910390fd5b6000610f626112bf565b61012f54600160a01b900460ff1615610f8d5760405162461bcd60e51b81526004016106c7906118aa565b604051821515907fbc08448eb710598e822470794891bc124e5da7b6e57471afb43b36bd03d37a8890600090a25061012d805460ff191682151517905560015b919050565b6000610fdc6112bf565b61012f54600160a01b900460ff16156110075760405162461bcd60e51b81526004016106c7906118aa565b6000821161102857604051631fbaba3560e01b815260040160405180910390fd5b478211156110495760405163fd7850ad60e01b815260040160405180910390fd5b6040516001600160a01b038416908390600081818185875af1925050503d8060008114611092576040519150601f19603f3d011682016040523d82523d6000602084013e611097565b606091505b5050809150508061068c57604051630dcf35db60e41b815260040160405180910390fd5b61012f54600160a01b900460ff16156110e65760405162461bcd60e51b81526004016106c7906118aa565b61012d5460ff1661110a57604051630e2f42c960e31b815260040160405180910390fd5b6000341161112b57604051631fbaba3560e01b815260040160405180910390fd5b60008061012e541161113e576000611157565b61012e5461114d606434611380565b61115791906113a2565b905080156112095761012f546040516000916001600160a01b03169083908381818185875af1925050503d80600081146111ad576040519150601f19603f3d011682016040523d82523d6000602084013e6111b2565b606091505b50509050806111d457604051638b3dac3760e01b815260040160405180910390fd5b6040518281527f69e27f80547602d16208b028c44d20f25956e1fb7d0f51d62aa02f392426f3719060200160405180910390a1505b604080513381523460208201527f543ba50a5eec5e6178218e364b1d0f396157b3c8fa278522c2cb7fd99407d4749101610bc5565b6112466112bf565b61013080546001600160a01b0383166001600160a01b031990911681179091556112786033546001600160a01b031690565b6001600160a01b03167f38d16b8cac22d99fc7c124b9cd0de2d3fa1faef420bfe791d8c362d765e2270060405160405180910390a350565b6001600160a01b03163b151590565b6033546001600160a01b03163314610be25760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016106c7565b61013080546001600160a01b0319169055610c5c81603380546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b60008261139d57634e487b7160e01b600052601260045260246000fd5b500490565b808202811582820484141761068c57634e487b7160e01b600052601160045260246000fd5b6000602082840312156113d957600080fd5b81356001600160e01b031981168114610a2b57600080fd5b80356001600160a01b0381168114610fcd57600080fd5b6000806000806080858703121561141e57600080fd5b611427856113f1565b9350611435602086016113f1565b93969395505050506040820135916060013590565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff811182821017156114895761148961144a565b604052919050565b600082601f8301126114a257600080fd5b813567ffffffffffffffff8111156114bc576114bc61144a565b6114cf601f8201601f1916602001611460565b8181528460208386010111156114e457600080fd5b816020850160208301376000918101602001919091529392505050565b6000806000806080858703121561151757600080fd5b611520856113f1565b935061152e602086016113f1565b925060408501359150606085013567ffffffffffffffff81111561155157600080fd5b61155d87828801611491565b91505092959194509250565b60008060006060848603121561157e57600080fd5b611587846113f1565b9250611595602085016113f1565b9150604084013590509250925092565b6000602082840312156115b757600080fd5b610a2b826113f1565b6000602082840312156115d257600080fd5b5035919050565b60008083601f8401126115eb57600080fd5b50813567ffffffffffffffff81111561160357600080fd5b60208301915083602082850101111561161b57600080fd5b9250929050565b6000806000806060858703121561163857600080fd5b611641856113f1565b9350602085013567ffffffffffffffff81111561165d57600080fd5b611669878288016115d9565b9598909750949560400135949350505050565b60008060006040848603121561169157600080fd5b61169a846113f1565b9250602084013567ffffffffffffffff8111156116b657600080fd5b6116c2868287016115d9565b9497909650939450505050565b6000602082840312156116e157600080fd5b81358015158114610a2b57600080fd5b600082601f83011261170257600080fd5b8135602067ffffffffffffffff82111561171e5761171e61144a565b8160051b61172d828201611460565b928352848101820192828101908785111561174757600080fd5b83870192505b848310156117665782358252918301919083019061174d565b979650505050505050565b600080600080600060a0868803121561178957600080fd5b611792866113f1565b94506117a0602087016113f1565b9350604086013567ffffffffffffffff808211156117bd57600080fd5b6117c989838a016116f1565b945060608801359150808211156117df57600080fd5b6117eb89838a016116f1565b9350608088013591508082111561180157600080fd5b5061180e88828901611491565b9150509295509295909350565b6000806040838503121561182e57600080fd5b611837836113f1565b946020939093013593505050565b600080600080600060a0868803121561185d57600080fd5b611866866113f1565b9450611874602087016113f1565b93506040860135925060608601359150608086013567ffffffffffffffff81111561189e57600080fd5b61180e88828901611491565b60208082526010908201526f14185d5cd8589b194e881c185d5cd95960821b604082015260600190565b6000825160005b818110156118f557602081860181015185830152016118db565b506000920191825250919050565b818382376000910190815291905056fea2646970667358221220607e390a299bdd0ca7d9af63ae6e334ff487176499600bbd15495a332ecf9d6b64736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class UpstreamCollectiveExternalToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.UpstreamCollectiveExternalToken__factory = UpstreamCollectiveExternalToken__factory;
UpstreamCollectiveExternalToken__factory.bytecode = _bytecode;
UpstreamCollectiveExternalToken__factory.abi = _abi;
